// extracted by mini-css-extract-plugin
module.exports = {"label":"_3ea6fa5da8--label--COGo1","lock":"_3ea6fa5da8--lock--fkunb"};